import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url, body) =>
  await AxiosConfig.create('post', url).call(body).getResponseData();

const useFetchOrCreateBlankSavDraft = (data = {}) => {
  const { customerOrder, savDraftId, ticketRef, createdBy } = data;

  const swrKey =
    customerOrder && ticketRef && createdBy
      ? [
          '/savdraft/fetchOrCreateBlank',
          customerOrder,
          savDraftId ?? null,
          ticketRef,
          createdBy,
        ]
      : null;

  const {
    data: response,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(
    swrKey,
    ([url]) => fetcher(url, data),
    {
      revalidateOnFocus: false,
    }
  );

  return {
    data: response,
    isLoading,
    isValidating,
    error,
    mutate,
  };
};

export default useFetchOrCreateBlankSavDraft;
